import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

//Components
import BlogItemAdmin from './BlogItemAdmin';

import { loadBlog } from '../../../actions/admin/blog';

//MUI
import {
    Button, Container, Grid, Typography, Alert, AlertTitle,
    Stack, LinearProgress, Box
} from '@mui/material';
import BookIcon from '@mui/icons-material/Book';

const Blog = () => {
    const dispatch = useDispatch();
    // entradas de blog
    const { blog_data: { list } } = useSelector(state => state.blog);

    const [loading, setLoading] = useState(false);
    
    useEffect(() => {
        dispatch(loadBlog(setLoading));
    }, []);

    return (
        <Container maxWidth='xl' sx={{ marginTop: '90px', mb: 5 }}>
            <Box display='flex' justifyContent='flex-start' gap='12px' flexWrap='wrap' mb={4}>
                <Typography variant='h5' gutterBottom sx={{my: 'auto'}}>Blog</Typography>
                <Link to="/nefro-admin/nuevo-blog" style={{ textDecoration: 'none' }}>
                    <Button
                        variant='outlined'
                        sx={{ textTransform: 'none', my: 'auto' }}
                        endIcon={<BookIcon />}
                    >
                        Crear nuevo blog
                    </Button>
                </Link>
            </Box>
            {
                loading ?
                    <Stack spacing={2}>
                        <Alert severity="info">
                            <Typography variant="h6" gutterBottom>
                                Cargando entradas de blog...
                            </Typography>
                        </Alert>
                        <LinearProgress color="info" />
                    </Stack>
                :
                    list.length > 0 ?
                        <Grid container spacing={4}>
                            {
                                list.map((item, i) => (
                                    <BlogItemAdmin
                                        key={i}
                                        item={item}
                                    />
                                ))
                            }
                        </Grid>
                        :
                        <Alert severity="info" variant="outlined">
                            <AlertTitle>Sin resultados</AlertTitle>
                            No existen entradas de blog.
                        </Alert>
            }
        </Container>
    );
};

export default Blog;